import { createContext, useContext } from 'react';

// Re-export actions context for convenience (actions are closely related to dropdown operations)
export { useDatePickerActions } from '../contexts/ActionsContext';

/**
 * Dropdown context for SgDatePicker
 * Contains dropdown state and positioning
 */
export interface DatePickerDropdownContextValue {
  isOpen: boolean;
  isPositioned: boolean;
  floatingStyles: React.CSSProperties;
  dropdownRef: React.RefObject<HTMLDivElement | null>;
  refs: {
    setFloating: (node: HTMLElement | null) => void;
    setReference: (node: HTMLElement | null) => void;
  };
}

const DatePickerDropdownContext = createContext<DatePickerDropdownContextValue | undefined>(undefined);

export const DatePickerDropdownProvider = DatePickerDropdownContext.Provider;

export function useDatePickerDropdown(): DatePickerDropdownContextValue {
  const context = useContext(DatePickerDropdownContext);

  if (!context) {
    throw new Error('useDatePickerDropdown must be used within DatePickerDropdownProvider');
  }

  return context;
}
